import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

const batteryIcon = getDesignSystemIcon('icon-battery-16.svg');

export const BatteryCompatibilityList: FC<{ batteries: string[] }> = ({ batteries }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-2 flex items-center gap-3 bg-secondary-light px-3 py-2">
      <div>
        <PhoenixIcon icon={batteryIcon} className="h-4 w-4" />
      </div>
      <div className="space-x-1">
        <span className="stihl-text-body-default-reg">
          {t('dashboard_compatibleProducts_card_value_batteries', { count: batteries.length })}
        </span>
        <span className="stihl-text-body-default-bold">{batteries.join(', ')}</span>
      </div>
    </div>
  );
};
